import { TableParams } from '../types';

export type GetTasksParams = TableParams & { [key: string]: string };

export type TaskInfo = {
  id?: string;
  name: string;
  status: 'active' | 'inactive' | null;
};

export type CreateTaskPayload = {
  name: string;
  status: 'active' | 'inactive';
};

export type UpdateTaskPayload = {
  id: string;
  body: CreateTaskPayload;
};

export type DeleteTaskPayload = {
  id: number;
};

export type TaskModalType = 'EDIT' | 'ADD' | false | null;

export const TaskModalTypes = {
  ADD: 'ADD',
  EDIT: 'EDIT',
};
